// extracted by mini-css-extract-plugin
export default {"label":"EventLabel_label__pKe1A","name":"EventLabel_name__4Q0uV","wrapper":"EventLabel_wrapper__ZOZXG","date":"EventLabel_date__kUdIG"};